import type { PageContext } from '@zto/zpage'
import dayjs from 'dayjs'

// 日志对话框
export function logDialog() {
  return {
    width: 600,
    top: '10vh',
    labelWidth: 0,
    itemSpan: 24,

    onShow: async ({ app, data }: PageContext) => {
      const res = await app.request({
        api: '/cabinet/admin/base/AdminBaseCommonQueryController/queryAuditLogPage',
        params: { bizNo: data.orderCode, logScene: 'oms.order_operate', pageIndex: 1, pageSize: 100 }
      })

      return {
        payload: {
          operateLogData: res.data
        }
      }
    },

    formItems: [
      {
        label: '',
        labelWidth: 0,
        type: 'edit-table',
        prop: 'operateLogData',
        span: 24,
        noOperation: true,
        autoHeight: true,
        border: true,
        columns: [
          {
            label: '操作时间',
            minWidth: 150,
            formatter: (row: any) => {
              return row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--'
            }
          },
          { prop: 'logDesc', label: '操作名称', minWidth: 160 },
          { prop: 'creator', label: '操作人', minWidth: 100 }
        ]
      }
    ],

    actions: {
      close: {}
    }
  }
}


// 申请退款
export const refundDialog = () => {
  return {
    dialog: ({ app }: PageContext) => {
      return {
        width: 500,
        labelWidth: 100,
        itemSpan: 24,
        title: '退款确认',

        // onShow: async ({ app, data }: PageContext) => {
        //   const res = await app.request({
        //     api: '/cabinet/admin/oms/AdminMktPromotionQueryController/getDetail',
        //     params: { promotionCode: data.promotionCode }
        //   })
        //
        //   return {
        //     payload: {
        //       ...res,
        //       pictureUrl: res.pictureUrl ? [res.pictureUrl] : []
        //     }
        //   }
        // },

        beforeSubmit: async ({ app, data }: PageContext, model: any, options: any) => {
          return true
        },

        onSubmit: async (payload: any, actionCfg: any, model: any, dialogExposed: any) => {
          // if (!api) {
          //   app.ui.showMessage({ type: 'warning', content: '无效操作' })
          //   return
          // }
          const { orderCode } = payload
          await app.request({
            api: '/cabinet/admin/oms/AdminOmsOrderCommandController/applyRefund',
            data: {
              orderCode
            }
          })
          app.ui.showMessage({
            type: 'success',
            message: '操作成功'
          })
          // app.triggerPageSearch()
          // dialogExposed.top?.close()
        },

        formItems: [
          {
            labelWidth:0,
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>您确定要为订单 <span style="font-weight: bolder; font-size: 20px">${data.orderCode}</span> 进行退款吗？</div>`
            },
            fullWidth: true
          },
          {
            labelWidth:0,
            type: 'html',
            html: ({ data }: PageContext) => {
              return `<div>退款金额：<span style="font-weight: bolder; font-size: 20px">¥${data.buyAmount}</span></div>`
            },
            fullWidth: true
          },
          {
            type: 'html',
            labelWidth: 0,
            html: `<div>系统将会按照原渠道进行退款</div>`
          },
        ],

        actions:{
          close: {},
          submit: { label: '确定' }
        }
      }
    }
  }

}

